import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { useStyles } from '@webapps/styles';
import { cx } from '@emotion/css';

const ColorPickerModal = ({ isOpen, onClose, predefinedColors = [], onColorChange, className }) => {
    const [color, setColor] = useState('#aabbcc');
    const { classes } = useStyles(styles);

    const handleColorChange = (newColor) => {
        setColor(newColor);
        if (onColorChange) onColorChange(newColor);
    };

    const hexToRgb = (hex) => {
        const sanitized = hex.replace('#', '');
        const bigint = parseInt(sanitized, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `${r}, ${g}, ${b}`;
    };

    const handleHexInputChange = (e) => {
        const val = e.target.value;
        if (/^#?[0-9A-Fa-f]{0,6}$/.test(val)) {
            const formatted = val.startsWith('#') ? val : `#${val}`;
            setColor(formatted);
            if (onColorChange) onColorChange(formatted);
        }
    };

    const handleRgbInputChange = (index, value) => {
        const rgb = hexToRgb(color).split(',').map((v) => parseInt(v.trim()));
        rgb[index] = Math.max(0, Math.min(255, Number(value)));
        const hex = `#${rgb.map((v) => v.toString(16).padStart(2, '0')).join('')}`;
        setColor(hex);
        if (onColorChange) onColorChange(hex);
    };

    const rgbValues = hexToRgb(color).split(',').map((v) => v.trim());

    return (
        <div className={cx(classes.modalContent, className)}>

            <HexColorPicker color={color} onChange={handleColorChange} className={classes.picker} />

            <div className={classes.inputsContainer}>
                <div className={classes.inputGroup}>
                    <label className={classes.label}>HEX</label>
                    <input
                        type="text"
                        value={color}
                        onChange={handleHexInputChange}
                        className={classes.input}
                    />
                </div>

                <div className={classes.inputGroup}>
                    <label className={classes.label}>RGB</label>
                    <div className={classes.rgbInputs}>
                        {rgbValues.map((val, i) => (
                            <input
                                key={i}
                                type="number"
                                min="0"
                                max="255"
                                value={val}
                                onChange={(e) => handleRgbInputChange(i, e.target.value)}
                                className={classes.rgbInput}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <div className={classes.predefinedWrapper}>
                {predefinedColors.map((preset, index) => (
                    <button
                        key={index}
                        className={classes.predefinedColor}
                        style={{ backgroundColor: preset }}
                        onClick={() => handleColorChange(preset)}
                    />
                ))}
            </div>
        </div>
    );
};

const styles = ({ spacing }) => ({
    modalContent: {
        padding: spacing(4),
        backgroundColor: '#f9f9fb',
        borderRadius: spacing(3),
        width: 360,
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(4),
        boxShadow: '0 4px 24px rgba(0,0,0,0.1)',
        fontFamily: 'Inter, sans-serif',
        position: 'absolute',

    },
    picker: {
        width: '100%',
        borderRadius: spacing(2),
        overflow: 'hidden',
    },
    inputsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(2),
    },
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(1),
    },
    label: {
        fontSize: 12,
        color: '#6b6b8b',
        fontWeight: 500,
    },
    input: {
        padding: spacing(1),
        fontSize: 14,
        border: '1px solid #d1d5db',
        borderRadius: spacing(1),
        backgroundColor: '#fff',
        outline: 'none',
    },
    rgbInputs: {
        display: 'flex',
        gap: spacing(1),
    },
    rgbInput: {
        flex: 1,
        padding: spacing(1),
        fontSize: 14,
        border: '1px solid #d1d5db',
        borderRadius: spacing(1),
        backgroundColor: '#fff',
        outline: 'none',
        textAlign: 'center',
    },
    predefinedWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacing(1),
        justifyContent: 'center',
    },
    predefinedColor: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: '2px solid #fff',
        boxShadow: '0 0 0 1px #ccc',
        cursor: 'pointer',
        transition: 'transform 0.2s ease',
    },
});

export default ColorPickerModal;



